import { Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SearchFail from "src/assets/images/SearchFail/searchFail.png";
import { RootState } from "src/store";
import { track } from "@amplitude/analytics-browser";

export default function HotelsWrapper() {
  const { t } = useTranslation();
  const isExpired = useSelector((state: RootState) => state.timer.isExpired);
  const { searchId } = useParams();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(isExpired && !!searchId);
  const handleClick = () => {
    setIsOpen(false);
  };
  const handleGoHome = () => {
    handleClick();
    track("Session Expired", { behaviourAfter: "Went Home" });
    navigate("./hotel");
  };
  const handleSearchAgain = () => {
    handleClick();
    track("Session Expired", { behaviourAfter: "Searched Again" });
    navigate(`/hotel/${searchId}?t=${Date.now()}`);
  };
  useEffect(() => {
    if (isExpired && searchId) {
      setIsOpen(true);
    }
  }, [isExpired, searchId]);
  return (
    <div>
      <Outlet />
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        closeIcon={null}
        className="w-120! h-120! aspect-square!"
        closable={false}
        mask={{
          closable: false,
        }}
        classNames={{
          container:"p-4!"
        }}
      >
        <div className="p-3! flex flex-col items-center gap-3">
          <div className="w-30 h-30">
            <img src={SearchFail} alt="" className="w-full h-full object-contain" />
          </div>
          <div className="text-2xl font-bold">{t("Hotels.common.pricesMayHaveChanged")}</div>
          <div className="text-center font-semibold text-font-subtle">{t("Hotels.common.refreshToSeeLatestFares")}</div>
          <div className="flex w-full gap-4">
            <Button className="bg-background-subtle! text-font-active! border-none! flex-1! p-6!" onClick={handleGoHome}>
              {t("Flights.common.goHome")}
            </Button>
            <Button className="text-font-inverted! bg-background-primary! border-none! flex-1! p-6!" onClick={handleSearchAgain}>
              {t("Flights.common.refreshSearch")}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
